import { useLanguage } from '@/i18n/LanguageContext';
import { useSiteSettings } from '@/hooks/useSiteSettings';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();
  const { settings } = useSiteSettings();
  const show = settings.show_contact_in_footer;
  const addressParts = [settings.contact_street, [settings.contact_postal_code, settings.contact_city].filter(Boolean).join(' '), settings.contact_country].filter(Boolean);
  const formattedAddress = addressParts.join(', ');
  const hasContactInfo = show && (settings.contact_email || settings.contact_phone || formattedAddress);

  return (
    <footer className="py-10 px-6 border-t border-border/20" role="contentinfo">
      {hasContactInfo && (
        <div className="max-w-xl mx-auto mb-6 flex flex-wrap justify-center gap-x-8 gap-y-2 text-xs text-muted-foreground">
          {settings.contact_email && (
            <a href={`mailto:${settings.contact_email}`} className="flex items-center gap-1.5 hover:text-foreground transition-colors">
              <Mail className="w-3 h-3" /> {settings.contact_email}
            </a>
          )}
          {settings.contact_phone && (
            <a href={`tel:${settings.contact_phone.replace(/\s/g, '')}`} className="flex items-center gap-1.5 hover:text-foreground transition-colors">
              <Phone className="w-3 h-3" /> {settings.contact_phone}
            </a>
          )}
          {formattedAddress && (
            <span className="flex items-center gap-1.5">
              <MapPin className="w-3 h-3 flex-shrink-0" /> {formattedAddress}
            </span>
          )}
        </div>
      )}
      <p className="text-xs tracking-widest uppercase text-muted-foreground font-sans text-center">
        {t.copyright}
      </p>
    </footer>
  );
};

export default Footer;
